document.addEventListener("DOMContentLoaded", function() {
  // Get the alert overlay
  const popupAlert = document.getElementById("popup-alert");

  // Check if the URL hash is "#popup"
  if (window.location.hash === "#popup") {
    // Show the popup by removing the "hidden" class and adding the "show" class
    popupAlert.classList.remove("hidden");
    popupAlert.classList.add("show");

    // Set a timeout to hide the popup after 3 seconds
    setTimeout(() => {
      popupAlert.classList.remove("show");
      popupAlert.classList.add("hidden");
    }, 3000);
  }
});